export const MEDIA_DATA = {
  kitToDownload: {
    url: 'https://drive.google.com/drive/folders/1K9pQidqfw19viC1Sfq_jk7fqQpzyxDS5?usp=sharing',
  },
  pressCoverage: {
    url: 'https://assets.r5y.io/lgo-live/media/pressCoverage.jpg',
  },
  tvInterviews: [
    {
      thumb: 'https://assets.r5y.io/lgo-live/media/tv-interviews/tv_1.jpg',
      description:
        'Jordan is joined by Adam Longhorn from Reality Games to talk about Landlord GO!, a new mobile game.',
      url: 'https://www.youtube.com/watch?v=XnS05QUL2C8',
      name: 'Good Day',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/tv-interviews/tvl_1.jpg',
    },
    {
      thumb: 'https://assets.r5y.io/lgo-live/media/tv-interviews/tv_2.jpg',
      description: 'Interview with Head of Studio at Canadian TV',
      url: 'https://ottawa.ctvnews.ca/video?clipId=2004551&binId=1.1487308&playlistPageNum=1#_gus&_gucid=&_gup=twitter&_gsc=kOK6uKa',
      name: 'CTV News',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/tv-interviews/tvl_2.jpg',
    },
    {
      thumb: 'https://assets.r5y.io/lgo-live/media/tv-interviews/tv_3.jpg',
      description: 'Interview with CEO of Reality Games at China24',
      url: 'https://www.youtube.com/watch?v=oU0xJ3jDfUo',
      name: 'China24',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/tv-interviews/tvl_3.jpg',
    },
  ],
  movies: [
    {
      top: 1,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_49.jpg',
      description: 'Millionaire Reacts: THE MOST EXPENSIVE HOME IN THE WORLD!',
      url: 'https://www.youtube.com/watch?v=3na3LEg3eNI',
      name: 'The Graham Stephan Show',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_49.jpg',
      viewCount: 510000,
    },
    {
      top: 1,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_47.jpg',
      description: 'Starting A Smart Home In 2021 | ULTIMATE GUIDE',
      url: 'https://youtu.be/eu1n_3-QSPs?t=154',
      name: 'Paul Hibbert',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_47.jpg',
      viewCount: 263000,
    },
    {
      top: 1,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_50.jpg',
      description: 'Millionaire Reacts: THE MOST EXPENSIVE HOME IN THE WORLD!',
      url: 'https://www.youtube.com/watch?v=3na3LEg3eNI',
      name: 'THE ICED COFFE HOUR',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_50.jpg',
      viewCount: 106000,
    },
    {
      top: 1,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_51.jpg',
      description: 'Installing a 6 Speed manual transmission in a Tesla',
      url: 'https://youtu.be/lPHea6GdQYw?t=209',
      name: 'Rich Rebuilds',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_51.jpg',
      viewCount: 844000,
    },
    {
      top: 1,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_53.jpg',
      description: 'Is an Angle Kit Worth It? - TESTED',
      url: 'https://youtu.be/eWHI7a6s0R4?t=104',
      name: 'Donut Media',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_53.jpg',
      viewCount: 1000000,
    },
    {
      top: 1,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_56.jpg',
      description: 'Inside the Most Expensive House in Dubai ($28 MILLION)',
      url: 'https://youtu.be/NZelsuXyO4w?t=325',
      name: 'Ben Morris',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_56.jpg',
      viewCount: 137000,
    },
    {
      top: 1,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_57.jpg',
      description: 'Day In The Life Of A 23 Year Old Entrepreneur (Realistic)',
      url: 'https://www.youtube.com/watch?v=iFmyJK8j0rk&ab_channel=JensenTung',
      name: 'Jensen Tung',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_57.jpg',
      viewCount: 970000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_37.jpg',
      description: 'ЕМ ШАУРМУ С САМОЙ ЛУЧШЕЙ ОЦЕНКОЙ В МОСКВЕ ***вкусно***',
      url: 'https://youtu.be/M9WHpNG1hws?t=19',
      name: 'Super Ctac',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_37.jpg',
      viewCount: 480000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_45.jpg',
      description: 'От первого лица: Свидание с одногруппницей',
      url: 'https://youtu.be/OBbm4bbpIb4?t=313',
      name: 'Руслан Гладенко',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_45.jpg',
      viewCount: 1500000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_20.jpg',
      description: "Ma l'ELETTRICO è il FUTURO...o NO?",
      url: 'https://www.youtube.com/watch?v=8CKn0uNhnUc&t=407s',
      name: 'Passione Motori',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_20.jpg',
      viewCount: 105000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_36.jpg',
      description: 'НАЧАЛЬНИК ПОЛИЦИИ ОБЛЫСЕЛ ОТ МАЗИ «САМСОН» | #ПолицияLIVE 🔴 13 серия',
      url: 'https://youtu.be/ENYctP60Ie4?t=933',
      name: 'Manifest Сhannel',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_36.jpg',
      viewCount: 550000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_19.jpg',
      description: '"MEGVETTÜK" A VOLT SULINKAT! 🏫',
      url: 'https://youtu.be/wqAE--3qrJ4?t=87',
      name: 'KD csapat ',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_19.jpg',
      viewCount: 269000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_12.jpg',
      description: 'ICH habe einen VERLASSENEN LAMBORGHINI gefunden in GTA 5!!',
      url: 'https://youtu.be/-OawhByjS_U?t=76',
      name: 'IDzock',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_12.jpg',
      viewCount: 270000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_59.jpg',
      description: 'Karens Confront my Loud Lamborghini',
      url: 'https://youtu.be/-oHx7XkPsaQ?t=120',
      name: 'effspot',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_59.jpg',
      viewCount: 234000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_21.jpg',
      description: 'IL MIO AMICO CAP CONTROLLA LA MIA VITA PER 24 ORE!!',
      url: 'https://www.youtube.com/watch?v=waisef69LiQ&t=222s',
      name: 'Cap e Kazu Reaction',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_21.jpg',
      viewCount: 353000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_24.jpg',
      description: '2021 Mercedes Benz S class S500 REVIEW on AUTOBAHN [NO SPEED LIMIT] by AutoTopNL',
      url: 'https://youtu.be/pYanCO-RgKo?t=44',
      name: 'AutoTopNL',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_24.jpg',
      viewCount: 494000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_3.jpg',
      description: 'Another Crazy Person Claims Australia Doesn’t Exist',
      url: 'https://youtu.be/iOmk7sXzEKw?t=39',
      name: 'Isaac Butterfield',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_3.jpg',
      viewCount: 500000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_4.jpg',
      description: 'MULHER CHAMANDO HOMEM CASADO PRA TR4NSAR!! - QMÉVC',
      url: 'https://youtu.be/5YdPoDTRZdY?t=527',
      name: 'Gerson',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_4.jpg',
      viewCount: 2000000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_5.jpg',
      description: 'COMPREI UMA CASA EM PORTO RICO * Land Lord GO *',
      url: 'https://www.youtube.com/watch?v=vPtsP3qZVOw&feature=youtu.be',
      name: 'Thiago Reis',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_5.jpg',
      viewCount: 400000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_6.jpg',
      description: 'КТО ПОСЛЕДНИЙ ПЕРЕСТАНЕТ СТРОИТЬ ИЗ ЛЕГО ПОЛУЧИТ 1000 $',
      url: 'https://youtu.be/hYEl3E_k8Zo?t=176',
      name: 'Lesha Maisak',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_6.jpg',
      viewCount: 2200000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_7.jpg',
      description: 'BLACK MAGIC WAS PERFORMED IN THIS HAUNTED HOUSE AND IT WENT WRONG..',
      url: 'https://youtu.be/fucMf76feDE?t=102',
      name: 'Moe Sargi',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_7.jpg',
      viewCount: 230000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_8.jpg',
      description: 'BIG 15.30 Update, FREE & PAY TO WIN Skin, Gangham Style Emote!',
      url: 'https://youtu.be/Ju34iW_1aqU?t=34',
      name: 'CampingRusher',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_8.jpg',
      viewCount: 97000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_9.jpg',
      description: 'MĚLI JSME BÝT V LIKE HOUSU... ODMÍTLI JSME!',
      url: 'https://youtu.be/lxp12-gyRfs?t=127',
      name: 'Pimps',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_9.jpg',
      viewCount: 240000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_10.jpg',
      description: 'hrajeme dokud NEVYHRAJEME! 🎮 [GEJMR a MenT]',
      url: 'https://youtu.be/xopfq1iQML0?t=97',
      name: 'GEJMR',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_10.jpg',
      viewCount: 142000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_11.jpg',
      description: 'Snažil Se Mě Okrást, Tak Jsem Ho HACKNUL a Zjistil, Kde Bydlí',
      url: 'https://youtu.be/lAMpCQCKfOQ?t=66',
      name: 'diradosveta',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_11.jpg',
      viewCount: 670000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_12.jpg',
      description: 'حاجات كنت اتمنى اعرفها في اوائل العشرينات',
      url: 'https://youtu.be/3hebkmsk6UY?t=123',
      name: 'MEKAWI',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_12.jpg',
      viewCount: 325000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_13.jpg',
      description: 'Η ΜΕΡΑ ΑΓΟΡΑΣ ΤΟΥ ΝΕΟΥ ΑΥΤΟΚΙΝΗΤΟΥ * ΣΤΡΑΒΩΣΕ *',
      url: 'https://youtu.be/_doQJWBIW1o?t=107',
      name: 'Panos Dent Vlogs',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_13.jpg',
      viewCount: 145000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_14.jpg',
      description:
        '【微辣大整蠱】帶煮詞人出發酒醉之旅！完成各位睇佢飲醉心願！酒精加濕器你哋又試過未？！最後究竟醉唔醉？│微辣 Manner',
      url: 'https://www.youtube.com/watch?v=HlTIAuPe2ho&ab_channel=%E5%BE%AE%E8%BE%A3Manner',
      name: '微辣 Manner',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_14.jpg',
      viewCount: 379000,
    },
    {
      top: 0,
      thumb: 'https://assets.r5y.io/lgo-live/media/video-thumbnails/yt_15.jpg',
      description: '磨刀霍Vlog#90｜微辣年會｜思男奪獎爆喊',
      url: 'https://youtu.be/wfVFoUGh4AA?t=65',
      name: 'Jeffrey Fok霍哥哥',
      logoUrl: 'https://assets.r5y.io/lgo-live/media/video-logos/vl_15.jpg',
      viewCount: 174000,
    },
  ],
  articles: [
    {
      name: 'Fun AR game entices Malaysians into playing a game of virtual Monopoly',
      url: 'https://www.malaymail.com/news/tech-gadgets/2020/08/14/fun-ar-game-entices-malaysians-into-playing-a-game-of-virtual-monopoly/1893737',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_1.jpg',
      description: 'Fun AR game entices Malaysians into playing a game of virtual Monopoly',
    },
    {
      name: 'New real estate AR game attracts thousands in Abu Dhabi',
      url: 'https://gulfbusiness.com/new-real-estate-ar-game-attracts-thousands-in-abu-dhabi/',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_2.jpg',
      description: 'New real estate AR game attracts thousands in Abu Dhabi',
    },
    {
      name: "Become a Cape Town real estate 'mogul' with AR game Landlord Go",
      url: 'https://www.timeslive.co.za/sunday-times/lifestyle/home-and-gardening/2020-08-12-watch-become-a-cape-town-real-estate-mogul-with-ar-game-landlord-go/',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_3.jpg',
      description: "Become a Cape Town real estate 'mogul' with AR game Landlord Go",
    },
    {
      name: 'New augmented reality game that lets players buy and sell real life buildings',
      url: 'https://business-review.eu/tech/bucharest-available-in-new-augmented-reality-game-that-lets-players-buy-and-sell-real-life-buildings-212401',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_4.jpg',
      description: 'New augmented reality game that lets players buy and sell real life buildings',
    },
    {
      name: 'Want a stake in IFC, Harbour City? Mobile game Landlord Go gives Hong Kong’s would-be property tycoons a taste of the Li Ka-shing high life',
      url: 'https://www.scmp.com/business/article/3097010/want-stake-ifc-harbour-city-mobile-game-landlord-go-gives-hong-kongs-would',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_5.jpg',
      description:
        'Want a stake in IFC, Harbour City? Mobile game Landlord Go gives Hong Kong’s would-be property tycoons a taste of the Li Ka-shing high life',
    },
    {
      name: 'Mobile game Landlord Go gives Hong Kong’s would-be property tycoons a taste of the Li Ka-shing high life',
      url: 'https://www.thestar.com.my/tech/tech-news/2020/08/12/mobile-game-landlord-go-gives-hong-kongs-would-be-property-tycoons-a-taste-of-the-li-ka-shing-high-life',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_6.jpg',
      description:
        'Mobile game Landlord Go gives Hong Kong’s would-be property tycoons a taste of the Li Ka-shing high life',
    },
    {
      name: "Landlord Go, cosa c'è da sapere sul Pokemon Go del mercato immobiliare",
      url: 'https://www.wired.it/gadget/videogiochi/2020/08/04/landlord-go-cosa-sapere/',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_7.jpg',
      description: "Landlord Go, cosa c'è da sapere sul Pokemon Go del mercato immobiliare",
    },
    {
      name: 'A New AR Game Allows Regular Folks to Play Landlord. We Decided to Test It',
      url: 'https://www.wealthmanagement.com/investment/new-ar-game-allows-regular-folks-play-landlord-we-decided-test-it',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_8.jpg',
      description: 'A New AR Game Allows Regular Folks to Play Landlord. We Decided to Test It',
    },
    {
      name: 'Augmented reality game Landlord Go goes viral in Delhi',
      url: 'https://asiacom.in/augmented-reality-game-landlord-go-goes-viral-in-delhi/',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_9.jpg',
      description: 'Augmented reality game Landlord Go goes viral in Delhi',
    },
    {
      name: 'Immobilien zum Nulltarif Wer als leidgeplagter Mieter mal die andere Seite kennenlernen will, kann mit einer App Haus für Haus kaufen - und sehen, wie einfach sich so Geld verdienen lässt',
      url: 'https://www.sueddeutsche.de/muenchen/null-acht-neun-immobilien-zum-nulltarif-1.4992601',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_10.jpg',
      description:
        'Immobilien zum Nulltarif Wer als leidgeplagter Mieter mal die andere Seite kennenlernen will, kann mit einer App Haus für Haus kaufen - und sehen, wie einfach sich so Geld verdienen lässt',
    },
    {
      name: 'Landlord Go: Virtuelles Monopoly mit Hamburger Immobilien',
      url: 'https://www.abendblatt.de/hamburg/article230151824/Landlord-Go-Virtuelles-Monopoly-Hamburger-Immobilien-Pokemon-Go-Augmented-Reality-Sehenswuerdigkeiten-Restaurants-AR-KI-Smartphone-Games.html',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_11.jpg',
      description: 'Landlord Go: Virtuelles Monopoly mit Hamburger Immobilien',
    },
    {
      name: "Game that's like 'Pokemon Go' meets 'Monopoly' takes off in Abu Dhabi",
      url: 'https://www.thenationalnews.com/arts-culture/game-that-s-like-pokemon-go-meets-monopoly-takes-off-in-abu-dhabi-1.1058908',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_12.jpg',
      description: "Game that's like 'Pokemon Go' meets 'Monopoly' takes off in Abu Dhabi",
    },
    {
      name: 'Landlord Go AR game provides new digital play for would-be developers',
      url: 'https://www.propertyweek.com/metropolis/a-real-game-changer/5109306.article',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_13.jpg',
      description: 'Landlord Go AR game provides new digital play for would-be developers',
    },
    {
      name: 'Landlord Go ! : construire son empire immobilier virtuel',
      url: 'https://www.lapresse.ca/maison/immobilier/2020-08-06/landlord-go-construire-son-empire-immobilier-virtuel.php',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_14.jpg',
      description: 'Landlord Go ! : construire son empire immobilier virtuel',
    },
    {
      name: "If you can't afford to buy a property, no matter. 'Landlord GO' allows you to become a tycoon in the Mother City, or elsewhere.",
      url: 'https://www.capetalk.co.za/articles/392965/keen-to-buy-a-cape-town-landmark-virtual-ownership-is-yours-with-a-new-game?ref=pid:112',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_15.jpg',
      description:
        "If you can't afford to buy a property, no matter. 'Landlord GO' allows you to become a tycoon in the Mother City, or elsewhere.",
    },
    {
      name: 'Ser agente del REAL ESTATE es casi un juego en MADRID',
      url: 'https://www.revistaad.es/arquitectura/articulos/ser-agente-del-real-estate-es-casi-un-juego-en-madrid/26821',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_16.jpg',
      description: 'Ser agente del REAL ESTATE es casi un juego en MADRID',
    },
    {
      name: 'Big data geolocation game offers chance to invest without risk',
      url: 'https://southfloridaagentmagazine.com/2020/07/30/big-data-geolocation-game-offers-chance-invest-without-risk/',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_17.jpg',
      description: 'Big data geolocation game offers chance to invest without risk',
    },
    {
      name: 'Be a Singapore real estate mogul in world’s first AR real estate game',
      url: 'https://sg.news.yahoo.com/singapore-real-estate-mogul-world-090636191.html?guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAAHCxyDAZLI27aayGPL4XTEU6kWYAG8NcK6Pex6DrypIGKvfLIvZQuCkyMFYtWOsdEcXJDhTju6HdrDQN-F1wxmotpkH9Onvxk3AK9FLuBb1OH9xC66cHI14dw2ldoOMYbZhRpImO9k2vPUIi5g__ZqkM4U-8exOtYO2y6hJaUTND&guccounter=2',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_18.jpg',
      description: 'Be a Singapore real estate mogul in world’s first AR real estate game',
    },
    {
      name: 'EL INMOBILIARIO VIRTUAL Lanzan un juego que permite a los jugadores comprar y vender propiedades del mundo real',
      url: 'https://www.elmundofinanciero.com/noticia/89370/sociedad/lanzan-un-juego-que-permite-a-los-jugadores-comprar-y-vender-propiedades-del-mundo-real.html',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_19.jpg',
      description:
        'EL INMOBILIARIO VIRTUAL Lanzan un juego que permite a los jugadores comprar y vender propiedades del mundo real',
    },
    {
      name: 'A Monopoly/Pokémon Go crossover – could this AR game help investors?',
      url: 'https://www.propertyinvestortoday.co.uk/breaking-news/2020/7/a-cross-between-monopoly-and-pokmon-go--could-this-ar-game-help-new-investors',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_20.jpg',
      description: 'A Monopoly/Pokémon Go crossover – could this AR game help investors?',
    },
    {
      name: 'Build a San Jose Empire in Virtual Reality Game ‘Landlord Go’',
      url: 'https://www.sanjoseinside.com/news/build-a-san-jose-empire-in-virtual-reality-game-landlord-go/',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_21.jpg',
      description: 'Build a San Jose Empire in Virtual Reality Game ‘Landlord Go’',
    },
    {
      name: 'Nuevo juego de realidad aumentada permite comprar y vender en el mundo real',
      url: 'https://www.lacapital.com.mx/noticia/80842-Nuevo_juego_de_realidad_aumentada_permite_comprar_y_vender_en_el_mundo_real',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_22.jpg',
      description: 'Nuevo juego de realidad aumentada permite comprar y vender en el mundo real',
    },
    {
      name: 'Bli virtuell fastighetsmogul i New York, Paris eller var som helst på jorden med Landlord Go.',
      url: 'https://www.enterprisemagazine.se/nyheter/artikel/kop-och-salj-verkliga-fastigheter-pa-din-mobil',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_23.jpg',
      description: 'Bli virtuell fastighetsmogul i New York, Paris eller var som helst på jorden med Landlord Go.',
    },
    {
      name: 'Landlord Go: Nowa gra mobilna, która pozwala handlować z graczami na całym świecie',
      url: 'https://gry.interia.pl/newsy/news-landlord-go-nowa-gra-mobilna-ktora-pozwala-handlowac-z-gracz,nId,4629916',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_24.jpg',
      description: 'Landlord Go: Nowa gra mobilna, która pozwala handlować z graczami na całym świecie',
    },
    {
      name: 'Polska gra Landlord GO pokonuje Pokemon GO',
      url: 'https://wiadomosci.onet.pl/kraj/polska-gra-landlord-go-pokonuje-pokemon-go/y9by8nw',
      thumb: 'https://assets.r5y.io/lgo-live/media/article-thumbnails/art_25.jpg',
      description: 'Polska gra Landlord GO pokonuje Pokemon GO',
    },
  ],
  pressKits: [
    {
      lang: 'en',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'bgr',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'chn',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'cze',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'dnk',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'nld',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'sau',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'est',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'fin',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'fra',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'deu',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'grc',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'isr',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'hun',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'ita',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'jpn',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'kor',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'nor',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'pol',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'prt',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'rou',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'rus',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'svk',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'esp',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'swe',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'tha',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'tur',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
    {
      lang: 'vnm',
      imgUrl: 'https://reality.co/wp-content/uploads/2020/07/us_gb.jpg',
      kitUrl: 'https://drive.google.com/drive/folders/1r38LD1tPgCobgIzdtQapJObEnXf55iXR?usp=sharing',
    },
  ],
};
